/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @angular-eslint/prefer-on-push-component-change-detection */
/* eslint-disable @angular-eslint/prefer-signals */

import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  templateUrl: './confirm-modal.component.html',
})
export class ConfirmModalComponent {
  @Input() title: string;
  @Input() text: string;

  modal: NgbActiveModal;

  constructor() {
    this.modal = inject(NgbActiveModal);
  }

  public confirm(): void {
    this.modal.close(true);
  }
}
